/**
 * SOLO BETTING (solo_betting) — the player picks a mode (pre-bet) and places
 * their selection bet. Mirrors the craps SIDEBET_BETTING setup: wallet opens,
 * the selection icons come from `availableSidebets` (LO/SEVEN/HI or the six
 * chuck-a-luck faces). There is NO lock-in step: placing the bet creates the
 * zone, which advances the server straight to FADE.
 */

import type { GameUpdate } from '@sdl/shared';
import { State } from '../State.js';

export class SoloBettingState extends State {
  async onEnter(update: GameUpdate): Promise<void> {
    const game = this.game;

    game.playerProfilesOverlay?.show();
    game.playerProfilesOverlay?.setMode('betting');
    game.countdownOverlay?.stop();

    await game.enterBettingMode({
      open: true,
      animated: update.animated,
      previousState: update.previousState,
    });

    // Placing the typed bet advances the round; no separate lock-in button.
    game.bettingHUD3D?.setLockInVisible(false);
    game.primeSidebetOptions(update);

    const mode = (update.customState?.soloMode as string) ?? 'hilo';
    game.instructionBanner?.show(
      mode === 'chuckaluck'
        ? { title: 'Pick a Number', text: 'Choose a face, then roll three dice' }
        : { title: 'Over or Under 7', text: 'Pick LO, HI, or 7' },
      update.animated,
    );

    this._updateProfiles(update);
    await this._checkPlayers(update);
  }

  async onUpdate(update: GameUpdate): Promise<void> {
    this._updateProfiles(update);
    await this._checkPlayers(update);
  }

  async onExit(_update: GameUpdate): Promise<void> {
    this._clearBettingActivity();
  }
}
